import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

interface EnterClaimsProps {
  onClose: () => void;
  viewOnly?: boolean;
  formik?: any;
  closeAndResetForm?: () => void;
}

const EnterClaims = ({
  onClose,
  viewOnly,
  formik,
  closeAndResetForm,
}: EnterClaimsProps) => {
  const handleSave = async () => {
    try {
      // Validate form first
      const errors = await formik.validateForm();
      if (Object.keys(errors).length > 0) {
        // If there are validation errors, submit form to trigger error display
        await formik.submitForm();
        return; // Exit early if validation fails
      }

      // If validation passes, proceed with save
      await formik.submitForm();
      // if (superBillRows && superBillRows.length > 0) {
      //   await saveBulkCalculationOfSuperBill();
      // }
      setTimeout(() => {
        closeAndResetForm?.();
      }, 1000);
    } catch (error) {
      console.error("Error saving claims:", error);
    }
  };
  // note : for reference check EnterSuperBills.tsx - for edit functionality
  return (
    <Box width={"100%"} mt={"1rem"}>
      {formik?.values?.claimId?.length > 0 && (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Claim Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formik?.values?.claimId?.map((row: any) => (
                <TableRow key={row.value}>
                  <TableCell>{row.label}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {!viewOnly && (
        <Box display="flex" justifyContent="flex-end" mt={2} gap={1}>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default EnterClaims;
